module.exports = __webpack_public_path__ + "media/brands/jmc-33548888.png";